import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-alarms-status-info",
  "use": "app-icon-alarms-status-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-alarms-status-info\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FAFBFF\" cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#6CBFFF\" d=\"M7 3h2v2H7zM7 7h2v7H7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol